import React from 'react'
import PropTypes from 'prop-types'
import { Panel, Hr, Margin, Text, Table } from 'shared/components'
import { InWinFilters } from './components/filters'

const InWinOverviewComponent = ({ columns, loadInWins, onSearch }) => (
  <Panel>
    <Text as="h1" size={18} bold>
      Charts
    </Text>
    <Margin tb={3}>
      <Hr width="full" />
    </Margin>
    <Margin>
      <InWinFilters debounce={250} onSearch={onSearch} />
    </Margin>
    <Table id="in-win-table" sortable columns={columns} loadData={loadInWins} />
  </Panel>
)

InWinOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadTriggers: PropTypes.func,
  loadInWins: PropTypes.func,
  onSearch: PropTypes.func,
}

export default InWinOverviewComponent
